import React from "react";
import GridContainer from "@jumbo/components/GridContainer";
import PageContainer from "@jumbo/components/PageComponents/layouts/PageContainer";
import IntlMessages from "@jumbo/utils/IntlMessages";
import { Divider } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import TicketDetailsContainer from "@jumbo/Dashboards/TicketsContainer/TicketDetailsContainer";

const breadcrumbs = [
    { label: <IntlMessages id={"sidebar.main"} />, link: "/" },
    { label: <IntlMessages id={"pages.tickets"} />, link: "/tickets" },
    {
        label: <IntlMessages id={"pages.ticketDetails"} />,
        isActive: true,
    },
];

const TicketDetails = () => {
    return (
        <PageContainer
            heading={<IntlMessages id="pages.ticketDetails" />}
            breadcrumbs={breadcrumbs}
        >
            <GridContainer>
                <Grid item xs={12}>
                    <div style={{ marginBottom: "10px" }}>
                        <IntlMessages id="pages.ticketDetails.description" />
                    </div>
                    <Divider />
                    <div style={{ marginTop: 24 }}>
                        <TicketDetailsContainer />
                    </div>
                </Grid>
            </GridContainer>
        </PageContainer>
    );
};

export default TicketDetails